<template>
  <div :style="{ backgroundColor: theme.screenBackgroundColor.value }" class="screen">
    <header class="header" :style="{ backgroundColor: theme.headerBackgroundColor.value }">
      <h1 class="title" :style="{ color: theme.headerTextColor.value }">{{this.$props.venue.venue_name}}</h1>
    </header>

    <div class="logo-container" v-if="venue.picture">
      <img class="logo" :src="venue.picture" alt="Venue Logo" />
    </div>

    <div
      class="tile"
      v-for="(bar, index) in bars"
      :key="index"
      :style="{ backgroundColor: theme.tileBackgroundColor.value }"
    >
      <h2 class="tile-title" :style="{ color: theme.PrimaryTextColor.value }">{{ bar.name }}</h2>
      <p class="tile-description" :style="{ color: theme.SecondaryTextColor.value }">{{ bar.description }}</p>
      <p class="tile-time" :style="{ color: theme.SecondaryTextColor.value }">{{ bar.wait }}</p>
    </div>
  </div>
</template>


<script>
export default {
  name: 'BarSelectionPreview',
  props: ['theme','venue'],
  data() {
    return {
      bars: [
        { name: '1st Pickup Location(Bar)', description: 'Bar by the entrance', wait: '1-2 Minutes' },
        { name: '2nd PickUp Location(Window)', description: 'Second floor by the staircase', wait: '1-2 Minutes' },
        { name: 'VIP Table', description: 'Served to Your Table', wait: '1-2 Minutes' }
      ]
    };
  }
};
</script>

<style scoped>
.screen {
  min-height: 100vh;
  padding: 16px;
}

.header {
  padding: 12px 16px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.logo {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 50%;

}

.tile {
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.tile-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 4px;
}

.tile-description,
.tile-time {
  font-size: 14px;
  margin-bottom: 2px;
}
</style>
